import {
  List,
  ListItem,
  Collapse,
  Typography,
  ListItemIcon,
} from "@mui/material";
import React, { useState } from "react";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import TypeWrapper from "../../utils/TypeWrapper";

const GlobalExpandNavItem = ({ item }) => {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  return (
    <>
      <ListItem
        button
        onClick={handleToggle}
        sx={{
          width: "92%",
          height: "50px",
          margin: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "&:hover": {
            borderRadius: "10px",
            backgroundColor: TypeWrapper.COLORS.BTN_THEME,
          },
        }}
      >
        <ListItemIcon
          sx={{
            marginLeft: "12px",
            marginRight: "-40px",
            color: TypeWrapper.COLORS.BLACK,
            "&:hover": { color: TypeWrapper.COLORS.HX_WHITE },
          }}
        >
          {item.icon && <item.icon />}
        </ListItemIcon>

        <Typography
          sx={{
            flexGrow: 1,
            fontSize: 15,
            fontWeight: "500",
            textAlign: "center",
            color: TypeWrapper.COLORS.LGT_BLACK,
            fontFamily: "'Poppins', sans-serif",
            "&:hover": { color: TypeWrapper.COLORS.HX_WHITE },
          }}
        >
          {item.title}
        </Typography>

        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {item.subItems.map((subItem, index) => (
            <ListItem
              button
              key={index}
              component="a"
              href={subItem.href}
              sx={{
                // pl: 4,
                justifyContent: "flex-center",
              }}
            >
              <ListItemIcon>{subItem.icon && <subItem.icon />}</ListItemIcon>

              <Typography
                sx={{
                  width: "100%",
                  fontSize: 14,
                  height: "40px",
                  fontWeight: "500",
                  textAlign: "center",
                  color: TypeWrapper.COLORS.LGT_BLACK,
                  fontFamily: "'Poppins', sans-serif",
                  "&:hover": {
                    color: TypeWrapper.COLORS.HX_WHITE,
                    backgroundColor: TypeWrapper.COLORS.BTN_THEME,
                  },
                  display: "flex",
                  borderRadius: "10px",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {subItem.title}
              </Typography>
            </ListItem>
          ))}
        </List>
      </Collapse>
    </>
  );
};

export default GlobalExpandNavItem;
